import { Container } from '@mui/material';
import React, { FC } from 'react';
import IframeComponent from 'src/components/ui-component/i-frame/IframeComponent ';
import ScrollToTop from '../../../components/layout/ScrollToTop';

const Impressum: FC<{}> = () => {
	return (
		<>
			<ScrollToTop />

			<Container>
				<IframeComponent src='https://datenschutzgenerator.hessen-agentur.de/projektImpressum.cfm?pid=28' />
			</Container>
		</>
	);
};
export default Impressum;

// {/* <Typography variant='h2' component='h1'>
// 					Impressum
// 				</Typography>
// 				<br></br>
// 				<br></br>
// 				<Stack direction={'row'} spacing={2}>
// 					<Stack flex={1} spacing={2}>
// 						<Typography variant='h5' component='h2'>
// 							Anbieter:
// 						</Typography>
// 						<Typography variant='h5' component='h2'>
// 							HA Hessen Agentur GmbH
// 						</Typography>
// 						<Box>
// 							<Typography>Mainzer Str. 118</Typography>
// 							<Typography>65189 Wiesbaden</Typography>
// 							<Typography>Tel. +49 611 9501780</Typography>
// 							<Typography>Fax +49 611 950178466</Typography>
// 							<Typography>
// 								E-Mail: <Link href={'mailto:info@hessen-agentur.de'}>info@hessen-agentur.de</Link>
// 							</Typography>
// 						</Box>
// 						<Box>
// 							<Typography variant='h5' component='h2'>
// 								Vertreten durch die Geschäftsführer:
// 							</Typography>
// 							<Typography>Folke Mühlhölzer (Vorsitzender) </Typography>
// 							<Typography>Dr. Rainer Waldschmidt </Typography>
// 						</Box>
// 						<Box>
// 							<Typography variant='h5' component='h2'>
// 								Registergericht und -nummer:
// 							</Typography>
// 							<Typography>Amtsgericht Wiesbaden, HRB 21418</Typography>
// 						</Box>
// 						<Box>
// 							<Typography variant='h5' component='h2'>
// 								Umsatzsteuer-Identifikationsnummer:
// 							</Typography>
// 							<Typography>DE 237911160</Typography>
// 						</Box>
// 						<Box>
// 							<Typography variant='h5' component='h2'>
// 								Aufsichtsratsvorsitzender:
// 							</Typography>
// 							<Typography>Staatsminister Kaweh Mansoori</Typography>
// 						</Box>
// 						{/* <Box>
// 							<Typography>Weitere Hinweise:</Typography>
// 							<Typography>Design</Typography>
// 							<Box>
// 								<Typography>B&IT Services GmbH</Typography>
// 								<Typography>Lietzenburger Str. 77</Typography>
// 								<Typography>10719 Berlin</Typography>
// 								<Typography>https://www.buit-group.com/</Typography>
// 							</Box>
// 						</Box> */}
// 	<br></br>
// 	<br></br>
// 	<Typography variant='h5' component='h2'>
// 		Technischer Betrieb und technische Realisation
// 	</Typography>
// 	<Box>
// 		<Typography>HA Hessen Agentur GmbH</Typography>
// 		<Typography>Innovations- und Nachhaltigkeitsprojekte</Typography>
// 		<Typography>Mainzer Str. 118</Typography>
// 		<Typography>65189 Wiesbaden </Typography>
// 		<Typography>www.hessen-agentur.de</Typography>
// 	</Box>
// 	<Box>
// 		<Typography>Ansprechpartner: </Typography>
// 		<Typography>Oliver Rindsfüsser, HA Hessen Agentur GmbH, oliver.rindsfuesser(a)hessen-agentur.de</Typography>
// 	</Box>

// 	<Typography variant='h3' component='h1'>
// 		Hinweise zur außergerichtlichen Streitbeilegung
// 	</Typography>
// 	<Box>
// 		<Typography>
// 			Zur Online-Streitbeilegung hat die EU-Kommission eine Plattform eingerichtet:{' '}
// 			<Link href={'https://www.ec.europa.eu/consumers/odr'}>https://www.ec.europa.eu/consumers/odr</Link>
// 		</Typography>
// 	</Box>
// 	<Typography>
// 		Wir sind weder bereit noch verpflichtet, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
// 	</Typography>
// </Stack>
// <Stack flex={1} spacing={2}>
// 	<Typography variant='h3' component='h1'>
// 		Bildnachweis und Urheberrechte
// 	</Typography>
// 	<Typography>© HA Hessen Agentur GmbH / Hessen Trade & Invest GmbH - alle Rechte vorbehalten.</Typography>
// 	<Typography>
// 		Falls nicht anders angegeben, unterliegen alle Seiten dem Urheberrecht (Copyright). Dies gilt insbesondere für Texte, Bilder,
// 		Wappen, Logos, Grafiken, Ton- und Videodateien einschließlich deren Anordnung auf den Webseiten.
// 	</Typography>
// 	<Typography>
// 		Eine Vervielfältigung oder Verwendung solcher Seiten (oder Teilen davon) in anderen elektronischen oder gedruckten Publikationen
// 		und deren Veröffentlichung (auch im Internet) ist nur nach vorheriger Genehmigung gestattet.
// 	</Typography>
// 	<Typography>
// 		Der Nachdruck und die Auswertung von Newsmeldungen und Artikeln sind mit Quellenangabe natürlich gestattet. Gleiches gilt für die
// 		gekennzeichneten Download-Angebote. Die Genehmigung zur Publikation der Webseiten kann die Redaktion erteilen (Impressum).
// 		Weiterhin können Bilder, Grafiken, Text- oder sonstige Dateien ganz oder teilweise dem Urheberrecht Dritter unterliegen.
// 	</Typography>
// 	<Typography>
// 		Alle innerhalb des Internetangebotes genannten und ggf. durch Dritte geschützten Marken- und Warenzeichen unterliegen
// 		uneingeschränkt den Bestimmungen des jeweils gültigen Kennzeichenrechts und den Besitzrechten der jeweiligen eingetragenen
// 		Eigentümer. Allein aufgrund der bloßen Nennung in unserem Internetangebot ist nicht der Schluss zu ziehen, dass Markenzeichen
// 		nicht durch Rechte Dritter geschützt sind.
// 	</Typography>
// 	<Typography variant='h3' component='h1'>
// 		Haftung für Inhalte
// 	</Typography>
// 	<Typography>
// 		Wir sind für die Inhalte unserer Internetseiten gemäß den allgemeinen Gesetzen verantwortlich. Alle Inhalte werden mit der
// 		gebotenen Sorgfalt und nach bestem Wissen erstellt. Soweit wir auf unseren Internetseiten mittels Hyperlink auf Internetseiten
// 		Dritter verweisen, können wir keine Gewähr für die fortwährende Aktualität, Richtigkeit und Vollständigkeit der verlinkten
// 		Inhalte übernehmen, da diese Inhalte außerhalb unseres Verantwortungsbereichs liegen und wir auf die zukünftige Gestaltung keinen
// 		Einfluss haben. Sollten aus Ihrer Sicht Inhalte gegen geltendes Recht verstoßen oder unangemessen sein, teilen Sie uns dies bitte
// 		mit.
// 	</Typography>
// 	<Typography>
// 		Die rechtlichen Hinweise auf dieser Seite sowie alle Fragen und Streitigkeiten im Zusammenhang mit der Gestaltung dieser
// 		Internetseite unterliegen dem Recht der Bundesrepublik Deutschland.
// 	</Typography>
// 	<Typography>
// 		Aus Gründen der leichteren Lesbarkeit wird auf eine geschlechtsspezifische Differenzierung von Funktions- bzw. personenbezogenen
// 		Bezeichnungen, wie zum Beispiel Teilnehmer/Innen, verzichtet. Entsprechende Begriffe gelten im Sinne der Gleichbehandlung für
// 		alle Geschlechter.
// 	</Typography>
// </Stack>
// </Stack> */}
